import { render, staticRenderFns } from "./AddictiveStuffsTable.vue?vue&type=template&id=10bf7546&"
import script from "./AddictiveStuffsTable.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports